import { EValidationErrorTrads } from "common/enums/trads/EValidationErrorTrads";
import { ValidationError } from "common/resources/Resource";

const labels: Record<string, string> = {
	creatorId: "Conseiller",
	officeId: "Cabinet",
	productsSubscribed: "Produits",
	productSheetId: "Produit",
	subscriberId: "Client",
	corporationSubscriberId: "Société",
	quantity: "Nombre de parts",
	paymentMethod: "Moyen de paiement",
	subscriptionProductType: "Type de souscription",
	subscriptionType: "Type de souscripteur",
	validationDate: "Date de validation",
	demembrementDuration: "Durée du démembrement",
	demembrementType: "Type de démembrement",
	viagerAge: "Âge de l’usufruitier",
};

export function manualSubscriptionValidationMessage(error: unknown): string | undefined {
	if (!Array.isArray(error)) return undefined;
	const messages: string[] = [];
	function visit(item: ValidationError, product?: string) {
		const row = /^\d+$/.test(item.property ?? "") ? `Produit ${Number(item.property) + 1}` : product;
		for (const [key, value] of Object.entries(item.constraints ?? {})) {
			const translated = EValidationErrorTrads[value as keyof typeof EValidationErrorTrads] ?? EValidationErrorTrads[key as keyof typeof EValidationErrorTrads];
			const message = key === "productNotAvailable" ? value : translated;
			if (!message) continue;
			const rendered = message.replace(/{{var(\d+)}}/g, (_, index: string) => String(item.contexts?.[key]?.[Number(index) - 1] ?? "la limite autorisée"));
			messages.push(`${row ? `${row}, ` : ""}${labels[item.property] ?? "Souscription"} : ${rendered}`);
		}
		item.children?.forEach((child) => visit(child, row));
	}
	for (const item of error) visit(item);
	return [...new Set(messages)].join(" ") || undefined;
}
